import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  // Número actualizado: (427) 110 7773
  const phoneNumber = '524271107773';
  const message = encodeURIComponent(
    'Hola, estoy interesado en los servicios de limpieza de CLEAN WORK. ¿Podrían brindarme más información?'
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center rounded-full bg-[#25D366] p-4 text-white shadow-lg transition-all hover:scale-110 hover:shadow-2xl md:bottom-8 md:right-8"
    >
      <MessageCircle className="h-7 w-7 md:h-8 md:w-8" />
    </a>
  );
};

export default WhatsAppButton;